module.exports = __webpack_public_path__ + "static/csc-4-15fc960300e27a6311e726505d29c085.jpg";